import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Console } from 'console';
import { ProductListResponseDataItem } from 'src/api/models';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {

  categoryId: number = 0;
  @Input() dataProd: Array<ProductListResponseDataItem>;
  @Input() dataExist: boolean = false;
  showLoader: boolean;
  lastId: number = 0;
  private parametersObservable: any;
  showPrev: boolean;
  showNext: boolean;
  toNext: boolean = true;

  constructor(public appService: AppService, public http: HttpClient, private activateRoute: ActivatedRoute) { }

  ngOnInit() {
    if (!this.dataExist) {
      console.log('next' + this.toNext);
      this.parametersObservable = this.activateRoute.params.subscribe(params => {
        const newLastId = params['lastId'] ? Number(params['lastId']) : 0;
        const newCategoryId = params['id'] ? Number(params['id']) : 1;
        if (this.lastId != newLastId || newCategoryId != this.categoryId) {
          this.categoryId = newCategoryId;
          this.lastId = newLastId;

          this.getProducts();
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.parametersObservable != null) {
      this.parametersObservable.unsubscribe();
    }
  }

  getProducts() {
    console.log('get' + this.toNext);
    this.dataProd = [];
    const methodName = '/api/products/' + (this.toNext ? 'getProductsListByCatId' : 'getProductsListByCatIdBack');
    console.log(methodName);
    const url = this.appService.baseUrl + methodName + '/' + this.categoryId + '/' + this.lastId;
    console.log(url);
    this.http.get<ProductListResponseDataItem[]>(url)
      .subscribe(data => {
        console.log('dsds')
        this.dataProd = data.sort((n1, n2) => n1.id - n2.id);
        this.showPrev = data.length > 0 && this.lastId != 0;
        this.showNext = data.length > 49 || (data.length == 0 && !this.toNext);
      },
        error => { },
        () => {
          this.showLoader = false;
        });
  }
}
